import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-spacer',
  templateUrl: './spacer.component.html',
  styleUrls: ['./spacer.component.scss'],
})
export class SpacerComponent {
  @Input() height = 20;

  getHeight(): string {
    return `${this.height}px`;
  }

  getWidth(): string {
    return `${this.height}px`;
  }
}
